import React from 'react';

export default function ClockOut() {
  return (
    <div className="form-container">
      <h2>Clock Out page has been moved to Clock In logic.</h2>
    </div>
  );
}
